import isNil from 'lodash.isnil';
import countBy from 'lodash.countby';
import {
    getMeasureInterpsFromResults,
    getInterpsForPeriodFromResults,
} from '../../../utils/shared/filterUtils';
import { INTERP, PERIOD } from '../../../constants/shared/CommonConstants';
import { getAvailablePeriods } from '../../../utils/shared/tableUtils';

const { RED, YELLOW, GREEN, BLUE } = INTERP;

const getStats = interps => {
    const redCount = countBy(interps)[RED];
    const yellowCount = countBy(interps)[YELLOW];
    const greenCount = countBy(interps)[GREEN];
    const blueCount = countBy(interps)[BLUE];
    const redStudentsNumber = isNil(redCount) ? 0 : redCount;
    const yellowStudentsNumber = isNil(yellowCount) ? 0 : yellowCount;
    const greenStudentsNumber = isNil(greenCount) ? 0 : greenCount;
    const blueStudentsNumber = isNil(blueCount) ? 0 : blueCount;

    return {
        redStudentsNumber: isNil(redStudentsNumber) ? 0 : redStudentsNumber,
        yellowStudentsNumber: isNil(yellowStudentsNumber) ? 0 : yellowStudentsNumber,
        greenStudentsNumber: isNil(greenStudentsNumber) ? 0 : greenStudentsNumber,
        blueStudentsNumber: isNil(blueStudentsNumber) ? 0 : blueStudentsNumber,
        totalStudentsNumber:
            redStudentsNumber + yellowStudentsNumber + greenStudentsNumber + blueStudentsNumber,
    };
};

export const getPercentageOfNumber = (number, totalNumber) =>
    totalNumber === 0 ? 0 : +((number * 100) / totalNumber).toFixed(0);

const getPercentage = stats => ({
    redPercentage: getPercentageOfNumber(stats.redStudentsNumber, stats.totalStudentsNumber),
    yellowPercentage: getPercentageOfNumber(stats.yellowStudentsNumber, stats.totalStudentsNumber),
    greenPercentage: getPercentageOfNumber(stats.greenStudentsNumber, stats.totalStudentsNumber),
    bluePercentage: getPercentageOfNumber(stats.blueStudentsNumber, stats.totalStudentsNumber),
});

export const getPerformanceByInterps = interps => {
    const stats = getStats(interps);
    const percentage = getPercentage(stats);
    return {
        red: {
            percentage: percentage.redPercentage,
            studentsTotalNumber: stats.redStudentsNumber,
        },
        yellow: {
            percentage: percentage.yellowPercentage,
            studentsTotalNumber: stats.yellowStudentsNumber,
        },
        green: {
            percentage: percentage.greenPercentage,
            studentsTotalNumber: stats.greenStudentsNumber,
        },
        blue: {
            percentage: percentage.bluePercentage,
            studentsTotalNumber: stats.blueStudentsNumber,
        },
    };
};

export const getOverallPerformance = (
    currentPeriod,
    selectedPeriod,
    grades,
    overalls,
    measuresForView,
    getAvailableMeasuresForView,
    gradeToMeasureMapper,
    toyPeriods,
) => {
    const performanceRows = { red: [], yellow: [], green: [], blue: [] };

    if (selectedPeriod === PERIOD.SUMMARY) {
        const availablePeriods = getAvailablePeriods(currentPeriod);
        toyPeriods.forEach(period => {
            if (availablePeriods.includes(period)) {
                const interps = getInterpsForPeriodFromResults(overalls, period);
                const performance = getPerformanceByInterps(interps);

                performanceRows.red.push(performance.red);
                performanceRows.yellow.push(performance.yellow);
                performanceRows.green.push(performance.green);
                performanceRows.blue.push(performance.blue);
            } else {
                performanceRows.red.push('-');
                performanceRows.yellow.push('-');
                performanceRows.green.push('-');
                performanceRows.blue.push('-');
            }
        });
    } else {
        const results = overalls.filter(result => measuresForView.includes(result.measure));
        getAvailableMeasuresForView(grades, measuresForView, gradeToMeasureMapper).forEach(
            measure => {
                const interpsByMeasure = getMeasureInterpsFromResults(results, measure.key);
                const measurePerformance = getPerformanceByInterps(interpsByMeasure);

                performanceRows.red.push(measurePerformance.red);
                performanceRows.yellow.push(measurePerformance.yellow);
                performanceRows.green.push(measurePerformance.green);
                performanceRows.blue.push(measurePerformance.blue);
            },
        );
    }

    return performanceRows;
};
